import Image from 'next/image';
import React from 'react'
import { validation } from '@/utils/validation';




const RegistrationButton = ({ label,image, onClick,active }) => {
  
  let style = '';
  if(label==='Campus' && active===true){
    style = 'py-2.5 mb-2 mr-2 px-5 text-sm font-semibold text-gray-900   outline bg-white rounded-lg border border-[#00BAF1] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-white-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-[#00BAF1]';
  }else if(label==='Corporate' && active===true){
    style = 'py-2.5 mb-2 mr-2 px-5 text-sm font-semibold text-gray-900   outline  bg-white rounded-lg border border-[#00BAF1] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-white-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-[#00BAF1]';
  }else if(label==='Student' && active===true){
    style = 'py-2.5 mb-2 mr-2 px-5 text-sm font-semibold text-gray-900   outline bg-white rounded-lg border border-[#00BAF1] hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-white-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-[#00BAF1]';
  }else{
    style = 'py-2.5 mb-2 mr-2 px-5 text-sm font-semibold text-gray-900  rounded-lg border border-[#00BAF1]';
  } 
    
    return (
        <button
          className={style}
          onClick={onClick}
        >
          <div className="flex justify-center gap-1">
          <Image src={image} alt ={`${label} icon`} className="w-6 h-5" />
          {label}
          </div>
          
        </button>
      );
}

export default RegistrationButton